import { debounce } from 'lodash';

export const pagination = {
  data() {
    return {
      search: '',
      options: {},
      footerProps: {
        itemsPerPageOptions: [25, 50, 250],
      },
      pagination: {
        current_page: 1,
        total: 0,
      },
    }
  },

  computed: {
    defaultParameters() {
      return {};
    }
  },

  watch: {
    options() {
      this.fetchAll();
    },
  },

  methods: {
    onSearch() {
      this.options.page = 1;
      this.fetchAll();
    },


    composeOptions(params) {
      const { page, sortBy, sortDesc, itemsPerPage } = this.options;
      return {
        ...this.defaultParameters, ...params, ...{
          page,
          per_page: itemsPerPage,
          sort: sortBy[0] || null,
          direction: sortBy[0] ? (sortDesc[0] ? 'desc' : 'asc') : null,
        }
      };
    },

    fetchAll: debounce(async function(params) {
      const parameters = params || {
        search: this.search
      };
      const options = this.composeOptions(parameters);
      this.isLoading = true;
      const { data } = await this.queryResults(options);
      if (data.meta) {
        this.pagination = {
          ...data.meta,
          page: data.meta.current_page,
          itemsPerPage: data.meta.per_page,
          pageStart: data.meta.from - 1,
          pageStop: data.meta.to,
          pageCount: data.meta.last_page,
          itemsLength: data.meta.total
        };
      }
      this.isLoading = false;
    }, 500),
  }
}
